<div class="step-content">

  <app-input-checkbox-list [formData]="selectConfig"></app-input-checkbox-list>

</div>
